import React, { useEffect } from 'react';
import { Stagger } from '../components/minimal/Stagger';

const STRAVA_CLIENT_ID = '191703';
const getStravaAuthUrl = (redirectPath: string = '/strava') => {
    const origin = typeof window !== 'undefined' ? window.location.origin : 'https://cabhinav.com';
    return `https://www.strava.com/oauth/authorize?client_id=${STRAVA_CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(origin)}&state=${encodeURIComponent(redirectPath)}&approval_prompt=force&scope=read,activity:read`;
};

const BIO = [
    {
        text: 'Hardware engineer ',
        href: 'https://grokipedia.com/page/Annapurna_Labs',
        label: '@annapurnalabs',
    },
    { text: 'MS ECE @ UW-Madison' },
    {
        text: 'Impedance matching ',
        href: 'https://grokipedia.com/page/wisconsin-electric-machines-and-power-electronics-consortium',
        label: '@wempec',
    },
    {
        text: 'Built GaN inverters ',
        href: 'https://x.com/peg_iitdh',
        label: '@pegiitdh',
    },
];

const CONTACT = [
    { kind: 'X', href: 'https://x.com/emotor', label: '@emotor' },
    { kind: 'Email', href: 'mailto:abhinavchinnusamy@gmail.com', label: 'abhinavchinnusamy@gmail.com' },
    { kind: 'Phone', href: 'sms:6086587885', label: '6086587885' },
];

const MinimalHome: React.FC = () => {
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const authParam = urlParams.get('auth');
        const refreshParam = urlParams.get('refresh');
        if (authParam === '1') {
            window.location.href = getStravaAuthUrl('/strava');
            return;
        }
        if (refreshParam === '1') {
            window.location.href = '/strava?refresh=true';
            return;
        }
    }, []);

    return (
        <Stagger className="flex flex-col">
            <h1 className="mb-12 text-base font-medium tracking-tight text-fg">
                Abhinav Chinnusamy
            </h1>

            {BIO.map((line) => (
                <p key={line.text} className="mb-1.5 text-sm leading-relaxed text-fg">
                    <span className="text-muted">— </span>
                    {line.text}
                    {line.href && line.label ? (
                        <a href={line.href} target="_blank" rel="noreferrer" className="quiet-link">
                            {line.label}
                        </a>
                    ) : null}
                </p>
            ))}

            <div className="mt-12 border-t border-line pt-6">
                <h2 className="mb-4 text-xs font-medium uppercase tracking-widest text-muted">
                    Contact
                </h2>
                <div className="flex flex-col gap-2 text-sm">
                    {CONTACT.map((item) => (
                        <p key={item.kind} className="flex flex-wrap gap-x-3">
                            <span className="w-12 text-muted">{item.kind}</span>
                            <a href={item.href} className="quiet-link text-fg">
                                {item.label}
                            </a>
                        </p>
                    ))}
                </div>
                <a
                    href="/assets/documents/abhinav-chinnusamy-resume.pdf"
                    target="_blank"
                    rel="noreferrer"
                    className="quiet-link mt-4 inline-block text-xs text-muted"
                >
                    Download resume
                </a>
            </div>
        </Stagger>
    );
};

export default MinimalHome;
